(function() {
  'use strict';
  angular.module('benefits')
  .component('procedureHistory', {
    bindings: {
      refId: '='
    },
    controller: ['benefitService', '$timeout', 'Members', '$stateParams', 'uiGridConstants', 'gridServices', '$state','claimService',
    function procedureHistoryController(benefitService, $timeout, Members, $stateParams, uiGridConstants, gridServices, $state, claimService) {
        var self = this;
        self.params = {};
        self.$onInit = function() {
          benefitService.checkPolicyForBenefitBlock(self.refId).then(function(data){
            self.isBenefitBlock = data;
          });
          benefitService.checkPolicyForClaimBlock(self.refId).then(function(data){
            self.isClaimBlock = data;
          });
          self.running = true;
          self.gridOptions = {
            enableSorting: true,
            enableColumnResizing: true,
            enableRowHeaderSelection: false,
            exporterMenuPdf: false,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            columnDefs: [
              { field: 'code', displayName: 'Procedure Code', cellFilter: 'procedureCode', enableHiding: false,headerTooltip: 'Procedure Code',
                sort: {
                  direction: uiGridConstants.ASC,
                  priority: 1
                },
              },
              { field: 'toothNumber', displayName: 'Tooth/Quadrant', enableHiding: false,headerTooltip: 'Tooth/Quadrant'},
              { field: 'surfaces',  displayName: 'Surfaces' ,enableHiding: false,headerTooltip: 'Surfaces'},
              { field: 'description', enableHiding: false,headerTooltip: 'Description'},
              { field: 'serviceDate', displayName: 'Date Of Service', cellFilter: 'portalDate', enableHiding: false,headerTooltip: 'Date Of Service',
                sort: {
                  direction: uiGridConstants.DESC,
                  priority: 0
                },
                sortingAlgorithm: gridServices.dateSort(self, (row) => row.serviceDate),
              }
            ],
            onRegisterApi: function(api) {
              self.gridApi = api;
            }
          };
          //Passing These along to claimsSearchController
          self.params.referenceId = $stateParams.referenceId;
         // benefitService.procedureHistoryPromise = Members.procedureHistory({referenceId: $stateParams.referenceId}).$promise; // Moved to dashboardController
          benefitService.procedureHistoryPromise.then((procedures) => {
            if(procedures.serviceUnavailable) {
              self.serviceUnavailable = true;
            }
            self.gridOptions.data = procedures.data;
            $timeout(() => { self.gridApi.core.handleWindowResize(); });
            self.running = false;
          });
        };
        self.claimHistory = claimHistory;
        function claimHistory() {
              claimService.claimsSearchParams({model: {}, referenceId: $stateParams.referenceId, status: {isMemberSearchOpen : true}});
              $state.go('claimsSearch');
        }
    }],
    templateUrl: '/js/benefits/procedureHistory.html' + appVersion
  });
})();
